import { observer } from 'mobx-react-lite'
import { type JobScopeInventoryItemViewModel } from '@/features/jobs/details/components/UpdateJobScopeDialog/ListItems/JobScopeInventoryItem/JobScopeInventoryItemViewModel'
import { JobScopeInventoryItem } from '@/features/jobs/details/components/UpdateJobScopeDialog/ListItems/JobScopeInventoryItem'

export interface JobScopeInventoryItemContainerProps {
  vm: JobScopeInventoryItemViewModel
  itemTestId?: string
}

export const JobScopeInventoryItemContainer = observer(
  function JobScopeInventoryItemContainer({
    vm,
    itemTestId,
  }: JobScopeInventoryItemContainerProps) {
    return (
      <JobScopeInventoryItem
        name={vm.name}
        description={vm.description}
        currentQuantity={vm.currentQuantity}
        newQuantity={vm.newQuantity}
        onRemove={vm.toggle}
        onQuantityChange={vm.setQuantity}
        itemTestId={itemTestId}
      />
    )
  },
)
